import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserMd, faAward } from "@fortawesome/free-solid-svg-icons";
import styles from "./Landing.module.css";

const DoctorProfile = () => {
  const qualifications = [
    "Doctor of Physiotherapy (DPT), Gold Medalist with 12+ years clinical leadership",
    "Former senior consultant across premier multi-specialty healthcare institutes",
    "Pioneering gentle, non-invasive therapies for chronic lumbar and cervical disorders",
    "Dedicated researcher leading clinical advancements in pediatric & sports rehabilitation",
  ];

  return (
    <section className={styles.infoSection}>
      <div className={`${styles.infoGrid} ${styles.infoGridReverse}`}>
        {/* Left: Details Text */}
        <div className={styles.infoText}>
          <div className={styles.heroBadge}>
            <FontAwesomeIcon icon={faUserMd} />
            <span>CLINICAL DIRECTOR</span>
          </div>

          <h3>Dr. Monika Sharma</h3>

          <p>
            <b>Dr. Monika Sharma</b> is an award-winning physiotherapist, founder of ReformMe Health Care, and a celebrated role model for ethical, science-backed, and compassionate physical rehabilitation in Gurugram.
          </p>

          <ul className={styles.featureList}>
            {qualifications.map((qual, idx) => (
              <li key={idx} className={styles.featureItem}>
                <FontAwesomeIcon icon={faAward} className={styles.featureIcon} />
                <span>{qual}</span>
              </li>
            ))}
          </ul>

          <p>
            A passionate advocate for holistic wellbeing, Dr. Sharma collaborates closely with every patient to rebuild strength and confidence. She actively conducts preventive health seminars and mentors upcoming physical therapists.
          </p>

          <div className={styles.highlightQuote}>
            "Philosophy: Restore natural alignment, Rebuild functional strength, and Empower every individual for a pain-free future."
          </div>
        </div>

        {/* Right: Portrait Card */}
        <div className={styles.infoImageCard}>
          <img
            src="https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&w=800&q=80"
            alt="Dr. Monika Sharma Physiotherapy Director"
          />
        </div>
      </div>
    </section>
  );
};

export default DoctorProfile;
